import { useState } from 'react';

export const useFormGeneratorHandleChangeV2 = (initialState = {}, initialErrors = {}, cbCustomHandleChange) => {
  const [state, setState] = useState(initialState); // state for input values

  const handleChange = (event) => {
    // ovo je univerzalni kod za upotrebu u formama unutar funkcionalnih komponenti sa useState hook-om.
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    if (typeof cbCustomHandleChange === 'function') {
      let _newState = cbCustomHandleChange(state, name, value); // cbCustomHandleChange mutate state
      if (_newState === false) {
        // cbCustomHandleChange refuse to mutate state
        // classic mutate
        setState({
          ...state,
          [name]: value
        });
      } else {
        // cbCustomHandleChange mutated state
        setState(_newState);
      }
    } else {
      // classic mutate
      setState({
        ...state,
        [name]: value
      });
    }
  }


  const setStateByMutator = (mutator, payload) => {
    //
    // - mutator must receive state as first argument and must return mutated state
    // - second argument, payload, is optional
    // - if u provide payload argument to mutate method that payload will be used as second argument to your mutator
    let _payload = null;
    if (typeof payload !== 'undefined') {
      _payload = payload;
    }
    if (typeof mutator === 'function') {
      // https://legacy.reactjs.org/docs/hooks-reference.html#functional-updates
      // Functional updates
      setState(prevState => {
        return mutator(prevState, _payload);
      });
    }
  };

  const [errors, setErrors] = useState(initialErrors); // state for input validation errors

  return { state, handleChange, setState, errors, setErrors, setStateByMutator };
};